module.exports = __webpack_public_path__ + "img/connected.fc5a6eb2.png";